import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Shield } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export default function AdminLogin() {
  const { login, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && user?.role === 'super_admin') navigate('/admin', { replace: true });
  }, [user, authLoading, navigate]);
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const userData = await login(form.email, form.password);
      if (userData?.role !== 'super_admin') {
        setError('Acesso restrito a administradores da plataforma.');
        return;
      }
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.detail || 'E-mail ou senha inválidos.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0f1e] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 bg-[#0f3d2e] rounded-xl flex items-center justify-center mb-4">
            <Shield size={24} className="text-white" />
          </div>
          <h1 className="text-white font-bold text-xl">TesIQ Admin</h1>
          <p className="text-white/40 text-sm mt-1">Painel de administração da plataforma</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs font-medium text-white/50 block mb-1.5">E-mail</label>
            <input
              type="email"
              autoComplete="username"
              required
              value={form.email}
              onChange={set('email')}
              placeholder="admin@tesiq.com.br"
              className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white placeholder-white/20 focus:outline-none focus:border-[#0f3d2e] focus:ring-1 focus:ring-[#0f3d2e]"
            />
          </div>

          <div>
            <label className="text-xs font-medium text-white/50 block mb-1.5">Senha</label>
            <div className="relative">
              <input
                type={showPw ? 'text' : 'password'}
                autoComplete="current-password"
                required
                value={form.password}
                onChange={set('password')}
                placeholder="••••••••"
                className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 pr-10 text-sm text-white placeholder-white/20 focus:outline-none focus:border-[#0f3d2e] focus:ring-1 focus:ring-[#0f3d2e]"
              />
              <button type="button" onClick={() => setShowPw(p => !p)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/30 hover:text-white/60">
                {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          {error && <p className="text-red-400 text-xs bg-red-400/10 border border-red-400/20 rounded-lg px-3 py-2">{error}</p>}

          <button type="submit" disabled={loading}
            className="w-full bg-[#0f3d2e] hover:bg-[#0a2e22] text-white font-medium py-2.5 rounded-lg text-sm transition-colors disabled:opacity-50 mt-2">
            {loading ? 'Entrando...' : 'Entrar no painel'}
          </button>
        </form>

        <p className="text-center text-white/20 text-xs mt-8">
          Acesso restrito · TesIQ v2.0
        </p>
      </div>
    </div>
  );
}
